'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

// components
import RecordMarker from './RecordMarker';
import Loader from '../Loader';

const GoogleMap = ({
  userGeolocation = null,
  defaultLatLon,
  results = null,
  markerCb,
  isLoading
}) => {
  const [markerHover, setMarkerHover] = useState({ index: -1, type: '' });
  const userLocation = !userGeolocation ? defaultLatLon : userGeolocation;
  if (userLocation && results) {
    return (
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY }}
        defaultCenter={defaultLatLon}
        defaultZoom={14}
        center={userGeolocation}
        yesIWantToUseGoogleMapApiInternals
      >
        {results.map((el, index) => (
          <RecordMarker
            key={el.reference}
            lat={el.geometry.location.lat}
            lng={el.geometry.location.lng}
            text={el.name}
            $index={index}
            $hoverIndex={markerHover}
            hoverEvent={(e) => {
              setMarkerHover({ index, type: e.type });
              markerCb(e.type === 'mouseenter' && { index, type: e.type });
            }}
          />
        ))}
      </GoogleMapReact>
    );
  }
  return null;
};

GoogleMap.propTypes = {
  userGeolocation: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
  defaultLatLon: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }).isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({})),
  markerCb: PropTypes.func.isRequired,
  updatedLocation: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
  userZipLocation: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
  isLoading: PropTypes.bool.isRequired,
  selectedLocation: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number })
};

export default GoogleMap;
